var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                staticStyle: {
                  "min-width": "160px",
                  width: "100%",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.backEventFlag = true
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState == -1 &&
                                    !_vm.isEditing
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onAdd()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.toEdit }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.copyJobHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isCooperate,
                                    expression: "!isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isCooperate,
                                    expression: "!isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isCooperate,
                                    expression: "isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptCooperateHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isCooperate,
                                    expression: "isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.isCooperate &&
                                      _vm.$checkPermission([
                                        "button_reVerify_reviewThrough"
                                      ]) &&
                                      _vm.pretrialReviewConfig,
                                    expression:
                                      "!isCooperate && $checkPermission(['button_reVerify_reviewThrough']) && pretrialReviewConfig"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewThroughHandler(1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewThrough")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.isCooperate &&
                                      _vm.$checkPermission([
                                        "button_reVerify_reviewRefusal"
                                      ]) &&
                                      _vm.pretrialReviewConfig,
                                    expression:
                                      "!isCooperate && $checkPermission(['button_reVerify_reviewRefusal']) && pretrialReviewConfig"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewRefusalHandler(1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewRefusal")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "logHandle",
                                  "split-button": "",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.logHandle()
                                  },
                                  command: function(p) {
                                    _vm.logCommand = p
                                    _vm.logHandle()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_LogRecord")) +
                                    " "
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.PortDataPushLog"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.PortDataPushLog")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "CargoMsg.Cargo_BusinessStatusChangeLog"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_BusinessStatusChangeLog"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.EdiStatusChangeLog"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.EdiStatusChangeLog"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew,
                                expression: "isNew"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(_vm.goBack)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "edit",
                                expression: "action==='edit'"
                              }
                            ],
                            staticClass: "btn-group-edit",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(_vm.lookHandler)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues2",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            display: "flex",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    mousemove: _vm.resetSopTooltip,
                                    dblclick: function($event) {
                                      return _vm.onBtnListDoubleClicked()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "14px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobState))]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      "font-size": "12px",
                                      padding: "5px 9px",
                                      color: "unset"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag && _vm.privilege.reBooking.bookingTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabBookingFCL",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _c("tab-booking-fcl", {
                                ref: "tabBookingFCL",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "processing-promise-list":
                                    _vm.processingPromiseList
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && _vm.privilege.reBooking.bookingTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabBookingMaster",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _c("tab-booking-master", {
                                ref: "tabBookingMaster",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "bookingWorkspace",
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: {
                                  addLcl: _vm.addBatchLcl,
                                  selectJob: function(jobUuid) {
                                    _vm.transferTargetRow("edit", jobUuid)
                                  },
                                  addSlavedJob: _vm.addSlavedJob,
                                  removeJobFromMaster: _vm.removeJobFromMaster,
                                  removeJob: _vm.removeJob
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.warehousing &&
                      _vm.privilege.reBooking.warehouseTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouse",
                                label: _vm.$t("SeaExport.WarehouseLoading")
                              }
                            },
                            [
                              _c("tab-warehouse", {
                                ref: "tabWarehouse",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditWarehouse
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.landTransportation &&
                      _vm.privilege.reBooking.reTruckingPage
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabTrucking",
                                label: _vm.$t("SeaExport.Trucking")
                              }
                            },
                            [
                              _c("tab-trucking", {
                                ref: "tabTrucking",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditTrucking
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.privilege.reBooking.containersLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.masterFlag &&
                      !_vm.isNew &&
                      _vm.privilege.reBooking.lclManagerLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabLclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-lcl-container", {
                                ref: "tabLclContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: {
                                  addSlavedJob: _vm.addSlavedJob,
                                  removeJobFromMaster: _vm.removeJobFromMaster,
                                  split: _vm.splitHandle
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabTradeDetail",
                                label: _vm.$t("SeaExport.TradeDetail")
                              }
                            },
                            [
                              _c("tab-trade-detail", {
                                ref: "tabTradeDetail",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.customs &&
                      _vm.privilege.reBooking.reCustomsInfo
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _c("tab-customs-info", {
                                ref: "tabCustomsInfo",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditCustoms
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.itmService
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabTradeCommission",
                                label: _vm.$t("SeaExport.TradeCommission")
                              }
                            },
                            [
                              _c("tab-trade-commission", {
                                ref: "tabTradeCommission",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.headwayTail &&
                      _vm.privilege.reBooking.headwayTail
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "tabRailwayHeadwayTail",
                                label: _vm.$t("RailwayExport.isHeadwayTail")
                              }
                            },
                            [
                              _c("tab-railway-headway-tail", {
                                ref: "tabRailwayHeadwayTail",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "RailwayVerify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "RailwayVerify"
                                },
                                on: { refreshCharges: _vm.refreshCharges }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.charge.advanceCharge
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "tabAdvanceCharge",
                                label: _vm.$t("SeaExport.AdvanceChargeInfo")
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.reBooking.portalState
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus"),
                                "cooperate-edit": _vm.cooperateEditOther
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "sop-template-config": _vm.sopTemplateConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.fileHistory.fileHistoryView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 16,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory"),
                                "cooperate-edit": _vm.cooperateEditOther
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: { context: _vm.context }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _vm.opVerifyFrameDialog.visible
        ? _c("op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "batch-pass-audit": _vm.opVerifyFrameDialog.batchPassAudit,
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack,
              "job-list": _vm.opVerifyFrameDialog.jobList || []
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                no: "DataPushChangeLog",
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "580px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c("div", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm.businessStatusDialog.visible
        ? _c("business-status-log-dialog", {
            attrs: {
              visible: _vm.businessStatusDialog.visible,
              "job-uuid": _vm.currentRow.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.businessStatusDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.ediStatusLogDialog.visible
        ? _c("edi-status-log-dialog", {
            attrs: {
              visible: _vm.ediStatusLogDialog.visible,
              "job-uuid": _vm.currentRow.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ediStatusLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: "RE",
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "new-job": _vm.batchCheckingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.RE,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2,
              "new-job": _vm.checkingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }